export default {
    en: "English",
    bg: "Български"
}